import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import lottery from './lottery';
import inquiry from './inquiry';

const contact = combineReducers({
  lottery,
  inquiry,
  lotteryLoadingStatus: loadingStatusAccordingToReducer('lotteryLoadingStatus'),
  inquiryLoadingStatus: loadingStatusAccordingToReducer('inquiryLoadingStatus'),
});

export default contact;



// WEBPACK FOOTER //
// ./src/modules/contact/reducers/contact.reducer.js